import { useFormikContext } from 'formik';
import { SparkBasicFormFooter } from 'sharedComponents/SparkForm';

type SparkSettingsFooterProps = {
  primaryButtonText: string;
};

function SparkSettingsFooter({ primaryButtonText }: SparkSettingsFooterProps) {
  const { dirty: isFormDirty } = useFormikContext();
  return (
    <>
      {isFormDirty && (
        <SparkBasicFormFooter
          shouldRenderResetButton={true}
          resetButtonText='Cancel'
          resetButtonStyles={{ width: '150px' }}
          primaryButtonText={primaryButtonText}
          containerProps={{
            justifyContent: 'space-between',
            position: 'sticky',
            paddingTop: '6px',
            bottom: '0',
            sx: {
              backgroundColor: '#fff',
            },
          }}
          primaryButtonStyles={{ width: '300px', textTransform: 'capitalize' }}
        />
      )}
    </>
  );
}

export default SparkSettingsFooter;
